import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { END_POINTS } from '../../Helper/Constant';
import { getApiRequest } from '../../services/getApiRequest';

import { showLoader, hideLoader } from '../loader/loaderSlice';

// Async thunk to fetch tournament data
export const fetchData = createAsyncThunk(
    'tournament/fetchData',
    async ({ id, userId }, { dispatch, rejectWithValue }) => {
        dispatch(showLoader());
        try {
            const url = `${END_POINTS.GET_TOURNAMENT_BY_ID}/${id}${userId ? `?userId=${userId}` : ""}`;
            const response = await getApiRequest(url);
            return response.tournament;
        } catch (error) {
            console.error('Fetch error:', error);
            return rejectWithValue(error.response?.data || error.message);
        } finally {
            dispatch(hideLoader());
        }
    }
);

const tournamentSlice = createSlice({
    name: 'tournament',
    initialState: {
        data: {},
        status: 'idle',
        error: null,
    },
    reducers: {
        // You can add synchronous reducers here
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchData.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchData.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchData.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload;
            });
    },
});

export default tournamentSlice.reducer;
